import { Grid, MenuItem, styled, Typography } from 'opensolar-ui'
import { CountryMapType } from 'pages/mfa/types'
import React from 'react'
import useExpoContext from './hooks/useExpoContext'
import { Locale } from './hooks/useUserDefaults'

const Wrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 20px;
`

const Container = styled('div', { name: 'Container' })`
  display: flex;
  flex-direction: column;
  padding: 24px;
  max-width: 600px;
  margin: 0 auto;
  background-color: #fff;
  gap: 4px;
`

const ListItem = styled('div', { name: 'ListItem' })`
  display: flex;
  align-items: center;
  gap: 12px;
`

const FlagCircle = styled('div', { name: 'FlagCircle' })`
  font-size: 30px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const Divider = styled('div', { name: 'Divider' })`
  width: 2px;
  background: #e5e7eb;
  margin: 20px 16px;
`

interface CountryAndLocaleSelectorProps {
  locales?: Locale[]
  availableCountries: CountryMapType[] | null
}

interface CountryOptionsProps {
  availableCountries: CountryMapType[] | null
  handleCountrySelect: (countryIso2: string) => void
  selectedCountry?: string | null
}

export const CountryOptions: React.FC<CountryOptionsProps> = ({
  availableCountries,
  handleCountrySelect,
  selectedCountry,
}) => {
  return (
    <>
      {availableCountries?.map((country) => (
        <MenuItem key={country.iso2} onClick={() => handleCountrySelect(country.iso2)}>
          <ListItem>
            <FlagCircle>{country.flag}</FlagCircle>
            <Typography textVariant={country.iso2?.toLocaleLowerCase() === selectedCountry ? 'body1Bold' : 'body1'}>
              {country.name}
            </Typography>
          </ListItem>
        </MenuItem>
      ))}
    </>
  )
}

const CountryAndLocaleSelector: React.FC<CountryAndLocaleSelectorProps> = ({ locales, availableCountries }) => {
  const { updateExpoState, selectedCountry, selectedLocale } = useExpoContext()

  const onSelectCountry = (country: string) => {
    if (!country) return
    updateExpoState({ selectedCountry: country })
  }

  const onSelectLang = (locale: string) => {
    updateExpoState({ selectedLocale: locale })
  }
  return (
    <Wrapper>
      <Grid container direction="row" justify="space-between">
        <Grid item>
          <Container>
            <CountryOptions
              availableCountries={availableCountries}
              selectedCountry={selectedCountry}
              handleCountrySelect={onSelectCountry}
            />
          </Container>
        </Grid>
        {locales && <Divider />}
        {locales && (
          <Grid item>
            <Container>
              {locales?.map((lang) => (
                <MenuItem key={lang.id} onClick={() => onSelectLang(lang.id)}>
                  <Typography textVariant={lang.id?.toLocaleLowerCase() === selectedLocale?.toLocaleLowerCase() ? 'body1Bold' : 'body1'}>
                    {lang.name}
                  </Typography>
                </MenuItem>
              ))}
            </Container>
          </Grid>
        )}
      </Grid>
    </Wrapper>
  )
}

export default CountryAndLocaleSelector
